//import IndexMain2 from '@/components/IndexMain2';
import HeaderUserTipsH5 from '@/app/eflayout/HeaderCommon/HeaderUser/HeaderUserNone/HeaderUserTipsWin/HeaderUserTipsH5';
import GoogleOneClickLogin from '@/components/GoogleOneClickLogin';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import { useLang } from '@/i18n';
import { getPageList } from '@/service';
import { initH1Tage, isReadyLang, redirectTo404 } from '@/utils';
import { appendScriptContentToHead } from '@/utils/singUtil/appendScriptToHead';
import ThemeChange from '@elem/compPage/ThemeChange';
import Product from 'lowcode/pages/product';
import { queryEditorDetailOnline } from 'lowcode/utils/service';
import * as Lowcomp from 'lowcomp/plugins/index-series/indexS';
import dynamic from 'next/dynamic';
import { useEffect } from 'react';

const IndexMain2: any = dynamic(() => import('@/components/IndexMain2'), { ssr: true });
// 是否是配置化新首页 [北美] US/CA  [欧洲]/EU/UK/DE/FR/IT/ES/NL [东亚]/JP/KR/CN [其他]/AU/ZA/SA/BR/MX/PH ====>> 还剩一个 TW台湾站
const newIndexArray: any = ['us', 'ca', 'au', 'za', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'jp', 'kr', 'cn', 'sa', 'br', 'mx', 'ph', 'nl', 'global']; //newHeaderLocales;
// const newIndexArray: any = ['us', 'ca', 'au', 'za', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'jp', 'kr', 'cn', 'sa']; //newHeaderLocales;

export default function Index({ homeData, SEO, id, data, locale, showThemeChange }: any) {
    const { t } = useLang('index');
    console.log('locale', locale);
    // en 只作为一个跳板，直接通过前端路由转到 /us，所以不影响 SEO
    if (locale === 'en') {
        return null;
    }
    const isNewIndex = newIndexArray.includes(locale as any);
    const isV2Flag = true;

    useEffect(() => {
        initH1Tage();

        locale === 'ca' &&
            setTimeout(() => {
                appendScriptContentToHead(`
                setTimeout(function () {
                    trackPageView();
                }, 40000);
                
                function trackPageView() {
                    const timeOnPage = Math.floor(performance.now() / 1000); // Calculate time on page in seconds
                    if (timeOnPage > 40 && typeof fbq === 'function') {
                        fbq('track', 'PageView40s');
                    }
                }
            `);
            }, 3000);
    });
    // 旧
    // const showNewTipsA = ['us', 'za', 'jp', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'kr'];
    const showNewTipsA = ['us', 'za', 'jp', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'kr', 'eu', 'br', 'mx', 'ph', 'nl', 'global'];

    let seoTitle = t('seo_title') || t('Ecoflow');
    let seoDesc = t('seo_desc');
    if (locale === 'us') {
        seoTitle = data?.thePage?.title || seoTitle;
        seoDesc = data?.thePage?.description || seoDesc;
    }
    return (
        <>
            {showThemeChange && <ThemeChange />}
            <PageLayout>
                <SEO title={seoTitle} description={seoDesc} />
                <SEOlinksA
                    list={['us', 'za', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis', 'sa', 'kr', 'br', 'mx', 'ph', 'nl', 'global']}
                    locale={String(locale)}
                    pathname={''}
                />
                {isNewIndex && (
                    <>
                        {showNewTipsA.includes(locale) && <HeaderUserTipsH5 />}
                        {/* <IndexLoginTips /> */}
                        <Product urlId={id} data={data} allTemp={Lowcomp} />
                    </>
                )}
                {!isNewIndex && homeData && <IndexMain2 homeData={homeData} />}
                <GoogleOneClickLogin />
            </PageLayout>
        </>
    );
}

export async function getServerSideProps(context: any) {
    const id: any = 'index';
    const locale: any = context.locale;
    if (locale !== 'en') {
        if (!isReadyLang(locale)) {
            return redirectTo404();
        }
    }
    let data = {
        thePage: {},
        theTemp: [],
        theData: {},
        theAttr: {},
        sqlData: {},
    };
    let homeData = null;
    // v2
    const isV2Flag = true;
    if (isV2Flag) {
        try {
            if (newIndexArray.includes(locale)) {
                //const cookieStr: any = context.req.headers.cookie;
                //const pageKey = getCookieFromVal(cookieStr, id);
                data = await queryEditorDetailOnline(id, locale);
            } else {
                const res = await getPageList(locale);
                if (res.code === '0' && res.data?.length > 0) {
                    homeData = res.data.find((el: { pageKey: string }) => el.pageKey === 'homepage');
                }
            }
        } catch (e) {
            console.log('e', e);
        }
    }

    // 首页换新弹窗时间线
    const START = new Date('2026/01/01 13:00:00 GMT+8').getTime();
    const END = new Date('2026/01/08 12:59:59 GMT+8').getTime();
    let now;
    try {
        const { _timer } = context.query;
        if (_timer) {
            now = new Date(_timer).getTime();
        } else {
            now = Date.now();
        }
    } catch (e) {
        now = Date.now();
    }
    const showTimeLine = now >= START && now <= END;
    // 首页换新弹窗是否关闭过
    const cookies = context.req.headers.cookie || '';
    const hasClosed = cookies.includes('new-home-theme-v3=true');

    return {
        props: {
            homeData: isV2Flag ? homeData || null : homeData || null,
            id,
            data,
            locale,
            showThemeChange: showTimeLine && !hasClosed && locale === 'us', //  在展示区间并且没有关闭过
        },
    };
}
